import React, {Component} from 'react';
import StationSnapshot from './StationSnapshot';
import {Row, Col, Button, Spin} from 'antd';
import {Link} from 'react-router';
import {API_URL} from '../constants/configValues';
import {UUID_NULL, CAMERA_SNAPSHOT_SMALL} from '../constants/defaultValues';

export default class PresentationGrid extends Component {
  constructor(props) {
    super(props)
  }

  handleSelection(station) {
    this.props.onRowSelection(station)
  }
  render() {
    const {stations, cameras, fetching} = this.props
    const body = stations && stations.length > 0
      ? stations.map(function(station) {
        const alarms = station.AlarmList

        const index = cameras.findIndex(function(camera) {
          return camera.StationID === station.ID && camera.IsMain
        })

        const linkSnapShot = index > -1 && cameras[index]
          ? `${API_URL}/v1/systems/${station.SystemID}/camera/${cameras[index].ID}/online/snapshot/${CAMERA_SNAPSHOT_SMALL}/0`
          : `${API_URL}/v1/systems/${station.SystemID}/camera/${UUID_NULL}/online/snapshot/${CAMERA_SNAPSHOT_SMALL}/0`
        return (
          <Col xs={{
              span: 24
            }} sm={{
              span: 12
            }} lg={{
              span: 8
            }} style={{
              padding: 1
            }} key={station.ID} >
            <Link to={`station/${station.ID}`} onClick={() => this.handleSelection(station)}>
              <StationSnapshot linkSnapShot={linkSnapShot} station={station}/>
            </Link>
          </Col>
        )
      }.bind(this))
      : <Row type="flex" align="middle" className="table-row" justify="center">Dữ liệu rỗng</Row>
    const content = fetching
      ? <span className="center"><Spin/></span>
      : body
    return (<Row>
      {content}
    </Row>)
  }
}



// WEBPACK FOOTER //
// ./src/components/PresentationGrid.js